import { Controller } from "@hotwired/stimulus"
import type { TurboBeforeFetchRequestEvent, TurboSubmitStartEvent } from "@hotwired/turbo"
import Confirmation from "../../confirmation"
import SelectionToolbarController from "../selection_toolbar_controller"
import type SearchFormController from "../search_form_controller"

export default class ListController extends Controller {
  static outlets = ["search-form"]
  static targets = [
    "deleteSelectedBtn",
    "toolbar",
  ]

  declare searchFormOutlet: SearchFormController
  declare hasSearchFormOutlet: boolean
  declare deleteSelectedBtnTarget: HTMLButtonElement
  declare toolbarTarget: HTMLElement

  handleAddReportSubmit(event: CustomEvent) {
    const { success } = event.detail
    if (!success) return

    const target = event.target
    if (target instanceof HTMLFormElement) {
      const modalEl = target.closest(".modal")
      const modal = globalThis.bootstrap.Modal.getInstance(modalEl)
      if (modal) {
        modal.hide()
      }
    }
  }

  getReportType(el: EventTarget | null) {
    if (el instanceof HTMLElement) {
      return el.closest("tr")?.dataset.reportType
    }
  }

  async confirmDelete(event: TurboBeforeFetchRequestEvent) {
    event.preventDefault()

    if (await Confirmation.confirmDelete(`this ${this.getReportType(event.target)} report`)) {
      event.detail.resume(null)
    }
  }

  deleteSelectedBtnTargetConnected(el: HTMLButtonElement) {
    const form = el.closest("form")
    if (!form) {
      return
    }

    form.addEventListener("turbo:before-fetch-request", async (event: TurboBeforeFetchRequestEvent) => {
      event?.preventDefault()

      if (await Confirmation.confirmBulkDelete("reports")) {
        event.detail.resume(null)
      } else {
        const selectionToolbar = SelectionToolbarController.getInstance(this.toolbarTarget)
        selectionToolbar?.clearSelected()
      }
    })

    form.addEventListener("turbo:submit-start", (event: TurboSubmitStartEvent) => {
      const selectionToolbar = SelectionToolbarController.getInstance(this.toolbarTarget)
      const ids = selectionToolbar?.selectedIds() || []
      ids.forEach(id => {
        event.detail.formSubmission.fetchRequest.body
          .append("ids[]", id)
      })
    })
  }

  appendSearchParams(event: TurboSubmitStartEvent) {
    if (!this.hasSearchFormOutlet) return

    const formData = new FormData(this.searchFormOutlet.formTarget)
    formData.forEach((value, key) => {
      if (typeof value === "string") {
        event.detail.formSubmission.fetchRequest.body.append(key, value)
      }
    })
  }

  getSelectionToolbarController(): SelectionToolbarController | null {
    return SelectionToolbarController.getInstance(this.toolbarTarget)
  }
}
